import React, { useCallback } from 'react';
import classnames from 'classnames';
import { PapiComment, PapiUser } from '@wix/da-papi-types';
import { getCommentBoxId } from '../../helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentPublisherResult } from '../../../CommentEditor/redux/types';
import { CommentableTypes } from '../../../Comment/redux/types';

import s from './ThreadPostbox.scss';

export interface Props {
  streamId: string;
  commentableTypeId: CommentableTypes;
  commentableItemId: number;
  parentId?: number;
  autoFocus?: boolean;

  position: string;
  parentComment?: PapiComment;
  currentUser?: PapiUser;
  canPostComment?: boolean;
  /**  when true, postbox toolbar is collapsible */
  isSmall?: boolean;
  className?: string;
  onThreadUpdated: (streamId: string, result: CommentPublisherResult) => void;
  /** will fire when a comment is posted */
  onPublishSuccess?: (result: CommentPublisherResult) => void;
}

const ThreadPostbox: React.FC<Props> = ({
  commentableItemId,
  commentableTypeId,
  position,
  parentComment,
  canPostComment,
  onThreadUpdated,
  onPublishSuccess,
  streamId,
  className,
  isSmall,
}) => {
  const handleThreadUpdated = useCallback(
    (result: CommentPublisherResult) => {
      onThreadUpdated && onThreadUpdated(streamId, result);
      onPublishSuccess && onPublishSuccess(result);
    },
    [onThreadUpdated, streamId, onPublishSuccess]
  );

  return (
    <div
      className={classnames(
        s['commentbox-wrapper'],
        position === 'topmost' && s['commentbox-wrapper-topmost'],
        position === 'bottom' && s['commentbox-wrapper-bottom'],
        className
      )}
    >
      <CommentBox
        id={getCommentBoxId(commentableTypeId, commentableItemId, position)}
        className={s['commentbox']}
        commentableType={commentableTypeId}
        commentableItemId={commentableItemId}
        replyComment={parentComment}
        onPublishSuccess={handleThreadUpdated}
        canPostComment={!!canPostComment}
        isSmall={isSmall}
      />
    </div>
  );
};
ThreadPostbox.displayName = 'ThreadPostbox';

export default ThreadPostbox;
